import { useState } from 'react'
import { cn } from '../../lib/cn.js'

/**
 * Subtle LLM follow-up prompts shown below a bot bubble (not in-bubble quick
 * replies or the bold suggestions strip).
 */
export function SuggestedPrompts({
  prompts = [],
  onSend,
  messageId = 'msg',
  /** `belowStrip` adds spacing when rendered under the inline suggestions strip (slide-out). */
  variant = 'default',
}) {
  const [clicked, setClicked] = useState(false)

  if (clicked || !Array.isArray(prompts) || prompts.length === 0) {
    return null
  }

  const handleClick = (text) => {
    const trimmed = String(text ?? '').trim()
    if (!trimmed || !onSend) return
    setClicked(true)
    onSend(trimmed)
  }

  return (
    <div
      className={cn(
        'flex w-full min-w-0 max-w-full flex-col gap-1.5 pl-0.5',
        variant === 'belowStrip' ? 'mt-2' : 'mt-1.5',
      )}
      role="group"
      aria-label="Suggested follow-up questions"
    >
      {prompts.map((prompt, index) => (
        <button
          key={`${messageId}-suggested-${index}`}
          type="button"
          onClick={() => handleClick(prompt)}
          className={cn(
            'w-fit max-w-full cursor-pointer rounded-full border border-[var(--color-border)]',
            'bg-transparent px-3 py-1.5 text-left text-sm text-[var(--color-surface-foreground)]',
            'transition-colors hover:bg-[var(--color-muted)]/60',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-brand)] focus-visible:ring-offset-1',
          )}
        >
          {String(prompt)}
        </button>
      ))}
    </div>
  )
}
